"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiTenant = instanceOfApiTenant;
exports.ApiTenantFromJSON = ApiTenantFromJSON;
exports.ApiTenantFromJSONTyped = ApiTenantFromJSONTyped;
exports.ApiTenantToJSON = ApiTenantToJSON;
exports.ApiTenantToJSONTyped = ApiTenantToJSONTyped;
/**
 * Check if a given object implements the ApiTenant interface.
 */
function instanceOfApiTenant(value) {
    if (!('tenantName' in value) || value['tenantName'] === undefined)
        return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined)
        return false;
    return true;
}
function ApiTenantFromJSON(json) {
    return ApiTenantFromJSONTyped(json, false);
}
function ApiTenantFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tenantName': json['tenant_name'],
        'tenantId': json['tenant_id'],
        'components': json['components'] == null ? undefined : json['components'],
        'businessHourBegin': json['business_hour_begin'] == null ? undefined : json['business_hour_begin'],
        'holidays': json['holidays'] == null ? undefined : json['holidays'],
        'allowSupervisor': json['allow_supervisor'] == null ? undefined : json['allow_supervisor'],
        'scheduleTool': json['schedule_tool'] == null ? undefined : json['schedule_tool'],
        'shorteningMeeting': json['shortening_meeting'] == null ? undefined : json['shortening_meeting'],
        'peopleCountsFormat': json['people_counts_format'] == null ? undefined : json['people_counts_format'],
        'roomNotice': json['room_notice'] == null ? undefined : json['room_notice'],
    };
}
function ApiTenantToJSON(json) {
    return ApiTenantToJSONTyped(json, false);
}
function ApiTenantToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tenant_name': value['tenantName'],
        'tenant_id': value['tenantId'],
        'components': value['components'],
        'business_hour_begin': value['businessHourBegin'],
        'holidays': value['holidays'],
        'allow_supervisor': value['allowSupervisor'],
        'schedule_tool': value['scheduleTool'],
        'shortening_meeting': value['shorteningMeeting'],
        'people_counts_format': value['peopleCountsFormat'],
        'room_notice': value['roomNotice'],
    };
}
